import React, { useState } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
} from "firebase/firestore";
import styled from "styled-components";
import Select from "react-select";

const CLOUDINARY_CLOUD_NAME = "dfjaij1fb"; // Replace with your Cloudinary cloud name
const CLOUDINARY_UPLOAD_PRESET = "premium_perfume"; // Replace with your unsigned upload preset

const seasonsOptions = [
  { value: "Spring", label: "Spring" },
  { value: "Summer", label: "Summer" },
  { value: "Fall", label: "Fall" },
  { value: "Winter", label: "Winter" },
];

const ProductForm = () => {
  const [product, setProduct] = useState({
    name: "",
    image: "",
    category: "",
    seasons: [],
    showInSlider: false,
    inStock: true,
  });
  const [imageFile, setImageFile] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (name === "image") {
      setImageFile(files[0]);
    } else if (type === "checkbox") {
      setProduct({ ...product, [name]: checked });
    } else {
      setProduct({ ...product, [name]: value });
    }
  };

  const handleSeasonsChange = (selectedOptions) => {
    if (selectedOptions.length <= 4) {
      setProduct({ ...product, seasons: selectedOptions });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let imageUrl = "";
      if (imageFile) {
        // Upload to Cloudinary
        const formData = new FormData();
        formData.append("file", imageFile);
        formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

        const response = await fetch(
          `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
          { method: "POST", body: formData }
        );
        const data = await response.json();
        imageUrl = data.secure_url;
      }

      const productRef = collection(db, "products");
      await addDoc(productRef, {
        ...product,
        image: imageUrl,
        seasons: product.seasons.map((season) => season.value),
      });

      setProduct({
        name: "",
        image: "",
        category: "",
        seasons: [],
        showInSlider: false,
      });
      setImageFile(null);
      alert("Product added successfully!");
    } catch (error) {
      console.error("Error adding product: ", error);
    }
  };

  // Custom styles for Select component
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#303030",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#303030",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "grey" : "#303030",
      color: "white",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "grey",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "white",
    }),
  };

  return (
    <Container>
      <h1>Regjistro Produkt</h1>
      <form onSubmit={handleSubmit}>
        <input
          name="name"
          value={product.name}
          onChange={handleChange}
          placeholder="Name"
          required
        />
        <span>
          <input name="image" type="file" onChange={handleChange} required />
        </span>
        <span>
          <select
            name="category"
            value={product.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Unisex">Unisex</option>
          </select>
          <Select
            className="select"
            isMulti
            options={seasonsOptions}
            value={product.seasons}
            onChange={handleSeasonsChange}
            closeMenuOnSelect={false}
            isOptionDisabled={() => product.seasons.length >= 4}
            styles={customStyles}
          />
        </span>
        <label>
          <input
            type="checkbox"
            name="inStock"
            checked={product.inStock}
            onChange={handleChange}
          />
          In Stock
        </label>
        <label>
          <input
            type="checkbox"
            name="showInSlider"
            checked={product.showInSlider}
            onChange={handleChange}
          />
          Show in Slider
        </label>
        <button type="submit">Add Product</button>
      </form>
    </Container>
  );
};

const Container = styled.div`
  padding: 7em 7%;
  text-align: center;
  h1 {
    font-family: "Comfortaa";
    font-size: 2.2em;
    font-weight: 200;
    margin-bottom: 10px;
  }
  form {
    margin: auto;
    background-color: #303030;
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 40px 30px;
    width: 700px;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    span {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 1em;
      input,
      textarea,
      select {
        width: 49%;
      }
    }
    input,
    textarea,
    select {
      width: 100%;
      background: none;
      color: white;
      font-size: 18px;
      font-family: "Comfortaa";
      border: 1px solid white;
      border-radius: 20px;
      padding: 14px 14px;
      outline: none;
    }
    option {
      color: black;
      padding: 7px;
    }
    button {
      background: white;
      font-family: "Comfortaa", sans-serif;
      padding: 12px 20px;
      border: none;
      border-radius: 30px;
      font-size: 19px;
      margin-top: 1em;
      cursor: pointer;
      transition: 0.4s;
      &:hover {
        background: var(--primaryColor);
        color: white;
      }
    }
  }
  @media (max-width: 960px) {
    form {
      width: 98%;
    }
  }
  @media (max-width: 550px) {
    padding: 6em 0%;
    form {
      width: 100%;
      padding: 30px 20px;
      span {
        flex-direction: column;
        input,
        textarea,
        select {
          width: 100%;
        }
      }
    }
  }
`;

export default ProductForm;
